/**
 * 当前文件中导出的内容目的为兼容微前端应用工程
 * @author  韦胜健
 * @date    2021/3/1 10:35
 */

/**
 * 该变量值从工程 link-front-micro 拷贝，不可修改
 * @author  韦胜健
 * @date    2021/3/1 10:39
 */
export const HAS_MAIN_APPLICATION = '@@HAS_MAIN_APPLICATION'           // 挂载在window对象上，用于判断启动应用类型的属性名

const LinkWindow = window as any

/**
 * 获取页面安全性
 * @author  韦胜健
 * @date    2021/3/1 10:35
 * @param	context				组件或者页面的，组件上下文对象（this）
 */
export function getSecurity(context: any): { page: any, security: any } {

	const nothing = {page: null, security: {}}

	if (!LinkWindow[HAS_MAIN_APPLICATION]) {
		/*没有微前端外壳*/
		const page = context.$lv.getPage(context)
		if (!page) {return nothing}
		if (!!page.pageSecurity && Object.keys(page.pageSecurity).length > 0) {return {page, security: page.pageSecurity}}
		if (!!page.tab && !!page.tab.data && !!page.tab.data.menuInfo) {return {page, security: page.tab.data.menuInfo.currentSecurity,}}
		return nothing
	} else {
		/*有微前端外壳*/
		let page = context
		while (!page.pageTabData && !!page.$parent) {
			page = page.$parent
		}
		if (!page) {
			return {
				page: null,
				security: {},
			}
		} else {
			return {
				page,
				security: (() => {
					if (!!page.pageSecurity) {return page.pageSecurity}
					if (!!page.pageTabData && !!page.pageTabData.data && !!page.pageTabData.data.menuInfo && page.pageTabData.data.menuInfo.currentSecurity) {
						return page.pageTabData.data.menuInfo.currentSecurity
					}
					return {}
				})(),
			}
		}
	}
}

export function installNavigatorMixin(Vue: any, mixin: any) {
	if (!LinkWindow[HAS_MAIN_APPLICATION]) {
		Vue.mixin(mixin) 							// 全局混入导航跳转相关函数
	}
}